var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSql(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "c89cf090-0e7d-426f-9971-6ebcb30a96f7",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "prime") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b454ce3c-30f4-4856-be86-7f37e0bf5d4b",
    "data-name": "database"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1C7,1,3,2.34,3,4V6c0,1.66,4,3,9,3s9-1.34,9-3V4C21,2.34,17,1,12,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,11C7,11,3,9.66,3,8v5c0,1.66,4,3,9,3s9-1.34,9-3V8C21,9.66,17,11,12,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,18c-5,0-9-1.34-9-3v5c0,1.66,4,3,9,3s9-1.34,9-3V15C21,16.66,17,18,12,18Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSql);
export default __webpack_public_path__ + "static/media/sql.0297ad44d45c2fe9282abc10ef0a6261.svg";
export { ForwardRef as ReactComponent };